<template>
  <div :class="paginaQuestionarioClassName">
    <baseLoader v-if="paginaLoader"></baseLoader>
    <div v-if="answerIdTerminale !== null" :class="rispostaTerminaleInfosClass">
      <div class="row w-100">
        <div class="col-1"></div>
        <div class="col-10" align="center">
          <div style="max-width: 1155px">
            <div v-if="true" class="row w-100">
           
            </div>
            <div v-if="renderTicketComponent" class="row w-100">
              <ticket
                :answerId="answerIdTerminale"
                :surveyId="surveyId"
                :setPaginaLoaderCallback="setPaginaloaderCallback"
                :getPaginaRingraziamentoCallback="getPaginaRingraziamentoCallback"
              ></ticket>
            </div>
            <div v-if="!renderTicketComponent" class="row w-100">
              <div   :class="documentiUtiliLayoutClassname">
                <documentiUtili
                    :answerId="answerIdTerminale"
                    :onLoadDataEnded="onResourcesLoadDataEnded"
                    :onLoadDataStarted="onResourceLoadDataStarted"
                    :setPaginaLoaderCallback="setPaginaloaderCallback"
                ></documentiUtili>
              </div>
              <div :class="faqLayoutClassname">
                <faq
                  :answerId="answerIdTerminale"
                  :onLoadDataEnded="onFaqLoadDataEnded"
                  :onLoadDataStarted="onFaqLoadDataStarted"
                  :setPaginaLoaderCallback="setPaginaloaderCallback"
                ></faq>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-1"></div>
      <div class="col-10" align="center">
        <questionario
          v-if="$store.state.userIsLoggedIn"
          :key="$store.state.userIsLoggedIn"
          :surveyId="surveyId"
          :paginaLoader="paginaLoader"
          :rispostaTerminaleCallback="rispostaTerminaleCallback"
          :rispostaCallback="rispostaCallback"
          :onIndietroClickCallback="onIndietroClickCallback"
          :onRicominciaQuestionarioClickCallback="onRicominciaQuestionarioClickCallback"
          :rispostaFinaleCallback="rispostaFinaleCallback"
          :setPaginaLoaderCallback="setPaginaloaderCallback"
          :onCreateSurveyLogCallback="onCreateSurveyLogCallback"
          :paginaRingraziamentoAperta="paginaRingraziamentoAperta"       
        />
      </div>
      <div class="col-1"></div>
    </div>
  </div>
</template>

<script>
import Questionario from "../questionario/Questionario.vue"
import Faq from "../contenitoreFaq/Faq.vue"
import DocumentiUtili from "../documentiUtili/DocumentiUtili.vue"
import BaseLoader from "../loaders/baseLoader/BaseLoader.vue"
import TicketDinamico from "../ticket/TicketDinamico.vue"
export default {
  name: "pagina-questionario",
  components: {
    questionario: Questionario,
    faq: Faq,
    documentiUtili: DocumentiUtili,
    ticket: TicketDinamico,
    baseLoader: BaseLoader,
 
   
  },
  props: {
    surveyId: {
            type: Number,
            default: process.env.VUE_APP_SURVEY_ID_1,
    },
  },

  data: function () {
    return {
      answerIdTerminale: null,
      renderFaqComponent: true,
      faqComponentDataLoaded: false,
      documentiUtiliComponentDataLoaded: false,
      renderDocumentiUtiliComponent: true,
      renderTicketComponent: false,
      childLoaders: {},
      paginaQuestionarioLoader: false,
      paginaRingraziamentoAperta: false
    };
  },
  methods: {
    setPaginaloaderCallback(value) {
     
      this.childLoaders = {...this.childLoaders, ...value}
   
      
    },
  getPaginaRingraziamentoCallback(paginaRingraziamentoAperta){
    this.paginaRingraziamentoAperta = paginaRingraziamentoAperta
  },
    rispostaTerminaleCallback(response,answerInfo) {
       
      if (answerInfo.id) {

        this.answerIdTerminale = answerInfo.id;
      }
    },
    rispostaCallback(response,answerInfo) {
        
        this.answerIdTerminale = null
    },
    rispostaFinaleCallback(type){
    
      switch(type){
        case "massei-voglio-essere-contattato":
          this.renderTicketComponent = true
          break
        case "massei-voglio-prenotare-appuntamento":
          if(this.$store.hasModule("questionarioStore-"+this.surveyId)){
            this.$store.commit("questionarioStore-"+this.surveyId+"/doResetQuiz")
          }  
           window.open("https://www.y-tyre.com/pneumaticimassei/prenotazioni-online/", "_blank");
          return null
        default:
          return null
      }
    },
   
    onIndietroClickCallback(){
        this.answerIdTerminale = null
        this.renderTicketComponent = false
    },
    onRicominciaQuestionarioClickCallback(){
        this.paginaRingraziamentoAperta= false;
        this.answerIdTerminale = null
        
    },
    onFaqLoadDataStarted(){
        this.renderFaqComponent = false;
        this.faqComponentDataLoaded = false
    },
    onCreateSurveyLogCallback(){
        this.renderTicketComponent = false
    },
    onFaqLoadDataEnded(response,faqs) {
     
      if (faqs && faqs.length > 0) {
        this.renderFaqComponent = true;
      } else {
        this.renderFaqComponent = false;
      }
      this.faqComponentDataLoaded = true
    },
    onResourcesLoadDataEnded(response,documenti) {
     
      if (documenti && documenti.length > 0) {
        this.renderDocumentiUtiliComponent = true;
      } else {
        this.renderDocumentiUtiliComponent = false;
      }
      this.documentiUtiliComponentDataLoaded = true
    },
    onResourceLoadDataStarted(){
        this.renderDocumentiUtiliComponent = false;
        this.documentiUtiliComponentDataLoaded = false
    },
  },
  watch: {
    
  },
  computed: {
    paginaLoader: function(){
      let loaders = Object.keys(this.childLoaders)
      let paginaLoader = false
      if(this.paginaQuestionarioLoader === true){
        paginaLoader = true
      }
      else if(loaders.length > 0){
        loaders.map((loader) => {
          if(this.childLoaders[loader] === true){
            paginaLoader = true
          }
        })
      }
      return paginaLoader
    },
    paginaQuestionarioClass: function () {
      if(this.showTicket){
        return "pagina-questionario ticket"
      }
      return "pagina-questionario"
    },
    rispostaTerminaleInfosClass: function() {
        if(this.faqComponentDataLoaded && this.documentiUtiliComponentDataLoaded){
            return "risposta-terminale-container-info visible"
        }
        return "risposta-terminale-container-info invisible"
    },
    paginaQuestionarioClassName: function () {
      if(this.renderTicketComponent){
        return "pagina-questionario hide-questions"
      }
      return "pagina-questionario"
    },

    documentiUtiliLayoutClassname: function () {
      if (this.renderFaqComponent && this.renderDocumentiUtiliComponent) {
        return "col-xl-4";
      }
      if (!this.renderDocumentiUtiliComponent) {
        return "col-0";
      }
      if (this.renderDocumentiUtiliComponent && !this.renderFaqComponent) {
        return "col-12";
      }
      return "col-0";
    },
    faqLayoutClassname: function () {
      if (this.renderFaqComponent && this.renderDocumentiUtiliComponent) {
        return "col-xl-8";
      }
      if (!this.renderFaqComponent) {
        return "col-0";
      }
      if (!this.renderDocumentiUtiliComponent && this.renderFaqComponent) {
        return "col-12";
      }
      return "col-0";
    },
  },
};
</script>
